import { useParams } from "react-router-dom";
import { PostDetailQuery } from "./PostDetailQuery";
import { EditorState, convertFromRaw, CompositeDecorator } from "draft-js";
import ReadOnlyEditor from "../../components/Editor/ReadOnlyEditor";
import { getUser } from "../../common/helper";
import { PostClapQuery } from "../PostList/PostClapQuery";
import { queryClient } from "../..";
import { ClapButton } from "../../components/ClapButton/ClapButton";
import { UserClapCount } from "../PostList/UserClapQuery";
import Helmet from "react-helmet";
import { isAndroid, isIOS, isMobile } from "react-device-detect";

function findLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
}
function getEditorContent(feed_description) {
  const rawEditorData = feed_description ? JSON.parse(feed_description) : null;
  if (rawEditorData !== null) {
    const contentState = convertFromRaw(rawEditorData);
    return EditorState.createWithContent(contentState, decorator);
  }
}

const Link = (props) => {
  const { url } = props.contentState.getEntity(props.entityKey).getData();
  return (
    <a
      rel="nofollow noreferrer"
      href={url}
      target="_blank"
      className="draftJsLinkifyPlugin__link__2ittM"
    >
      {props.children}
    </a>
  );
};

const decorator = new CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: Link,
  },
]);

export default function PostDetail() {
  const url = window.location.url;
  const { id } = useParams();
  const { mutate } = PostClapQuery();
  const { data, isSuccess } = PostDetailQuery(id);
  const { data: userClapCountList = {}, isSuccess: userClapCountSuccess } =
    UserClapCount();
  const post = data?.data?.response?.results[0];
  const userId = getUser();

  const onClapClick = (feedId) => {
    const data = {
      feed_id: feedId,
      clap_count: 1,
      user_id: parseInt(userId),
    };
    mutate(data, {
      onSuccess: (result) => {
        queryClient.setQueryData("UserClapCount", (oldData) => {
          oldData[result?.data?.feed_id] = result?.data?.clap_count;
          return oldData;
        });
        queryClient.setQueryData("PostList", (oldData) => {
          oldData.pages.forEach((page, index) => {
            let a = page?.results.findIndex(
              (feed) => feed?.feed_id === result?.data?.feed_id
            );
            if (a >= 0) {
              oldData.pages[index].results[a].total_clap_count =
                result.data.total_clap_count;
            }
          });
          return oldData;
        });
      },
    });
  };
  const onShare = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    const feed_title = post.feed_title.replace(/ /g, "-");
    const feedUrl = `${window.location.origin}/post/${post.feed_id}/${feed_title}`;
    if (isMobile) {
      let message = {
        msg: post.share_message,
        url: feedUrl,
      };
      message = JSON.stringify(message);

      if (isIOS) {
        window.location = `share://?${message}`;
      }
      /*eslint-disable no-undef*/
      if (isAndroid) {
        Android.shareBtnClicked(
          post.feed_image,
          `${post.share_message} ${feedUrl}`
        );
      }
    }
  };
  const onUrlClick = (url) => {
    if (isMobile) {
      if (isAndroid) {
        Android.openBrowser(url);
      }
      if (isIOS) {
        window.webkit.messageHandlers.openBrowser.postMessage({
          url,
        });
      }
    }
  }
  return (
    <div>
      {isSuccess && (
        <div>
          <Helmet>
            <title>Blog</title>
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content={post.feed_title} />
            <meta property="og:description" content={post.feed_subtitle} />
            <meta property="og:image" content={post.feed_detail_page_image} />
            <meta property="og:site_name" content="Impact - Get Fit Do Good" />
            <meta property="fb:app_id" content="1824817291112552" />
          </Helmet>
          <img
            src={post.feed_detail_page_image}
            className="-mb-10 w-full"
            alt="feed-banner"
          />
          <div className="p-4 relative rounded-t-[40px] bg-white">
            <h1 className="text-base font-semibold text-lg my-4">
              {post.feed_subtitle}
            </h1>

            <ReadOnlyEditor
              editorState={getEditorContent(post.feed_description)}
              readOnly={true}
            />
          </div>
          <div onClick={() => { onUrlClick(post.feed_url) }} className="px-4 py-1 relative rounded-t-[40px] bg-white">
            <a>{post.feed_url}</a>
          </div>
          <div className="flex items-center justify-center p-4">
            <button
              type="button"
              className="rounded-full text-sm font-bold text-white focus:text-white  bg-sky-400 hover:bg-sky-500 focus:ring-4 focus:ring-blue-300 font-medium text-sm h-14 text-center w-4/6"
              onClick={onShare}
            >
              share
            </button>
            <div className="flex items-center w-2/6 justify-center relative">
              {Boolean(userId) && userClapCountSuccess && (
                <ClapButton
                  onClapClick={onClapClick}
                  feedId={post.feed_id}
                  userClapCount={userClapCountList[post.feed_id]}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
